import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddOrganisationUserMutationVariables = Types.Exact<{
  user_id: Types.Scalars["String"];
  organisation_id: Types.Scalars["Int"];
}>;

export type AddOrganisationUserMutation = { __typename?: "mutation_root" } & {
  insert_organisation_users_one?: Types.Maybe<
    { __typename?: "organisation_users" } & Pick<Types.Organisation_Users, "id">
  >;
};

export const AddOrganisationUserDocument = gql`
  mutation AddOrganisationUser($user_id: String!, $organisation_id: Int!) {
    insert_organisation_users_one(
      object: { user_id: $user_id, organisation_id: $organisation_id }
      on_conflict: {
        constraint: organisation_users_organisation_id_user_id_key
        update_columns: [organisation_id, user_id]
      }
    ) {
      id
    }
  }
`;

export function useAddOrganisationUserMutation() {
  return Urql.useMutation<
    AddOrganisationUserMutation,
    AddOrganisationUserMutationVariables
  >(AddOrganisationUserDocument);
}
